
    // this file was auto generated by python script
    import Home from './Home';
    export default Home;
    